import type { SupportedBCP47Locale } from '../types/locale'
import { SupportedLocales } from '../types/locale'

const LOCALE_MAP = new Map<SupportedLocales | SupportedBCP47Locale, SupportedBCP47Locale>([
  [SupportedLocales.EnCA, 'en-CA'],
  [SupportedLocales.FrCA, 'fr-CA'],
  [SupportedLocales.EnUS, 'en-US'],
  ['en-CA', 'en-CA'],
  ['fr-CA', 'fr-CA'],
  ['en-US', 'en-US'],
])

export function normalizeLocale(
  locale: SupportedLocales | SupportedBCP47Locale,
  fallback: SupportedBCP47Locale = 'en-CA'
): SupportedBCP47Locale {
  const normalized = LOCALE_MAP.get(locale)
  if (normalized === undefined) {
    // eslint-disable-next-line no-console
    console.error(`Unsupported locale: "${locale}". Falling back to "${fallback}".`)
    return fallback
  }
  return normalized
}
